import React, { useEffect } from 'react';
import ExternalCalButton from '../ExternalCalButton';
import SpaceSelectDropdown from '../SpaceSelectDropdown';
import useCalendarSyncFlowStore, {
  CAL_TYPE_ICAL,
  CAL_TYPE_SYNC
} from '../../../store/sync-flow/useCalendarSyncFlowStore';
import { Text } from '@ps-design-system/components/Text';
import useCalendarStore from '../../../store/calendar/useCalendarStore';
import ExternalCalSelectionStrings from './strings';

const ExternalCalSelection = () => {
  const spaces = useCalendarStore((state => state.spaces));
  const currentCalSelectedSpaceId = useCalendarStore((state => state.selectedSpaceId));

  const setSpaceId = useCalendarSyncFlowStore((state) => state.setSpaceId);
  const calendarType = useCalendarSyncFlowStore((state) => state.calendarType);
  const setCalendarType = useCalendarSyncFlowStore((state) => state.setCalendarType);

  useEffect(() => {
    if (1 === spaces.length) {
      setSpaceId(spaces[0]._id);
    }
  }, [spaces]);

  const handleSyncCalSelected = () => {
    setCalendarType(calendarType === CAL_TYPE_SYNC ? null : CAL_TYPE_SYNC);
  };

  const handleICalSelected = () => {
    setCalendarType(calendarType === CAL_TYPE_ICAL ? null : CAL_TYPE_ICAL);
  };

  const handleSpaceSelected = (spaceId) => {
    setSpaceId(spaceId);
  };

  return (
    <div className="ExternalCalSelection">
      {1 < spaces.length && (
        <>
          <Text typeface="body-2-m" className="ExternalCalSelection_select-space-title">
            {ExternalCalSelectionStrings.selectSpaceTitle}
          </Text>
          <SpaceSelectDropdown
            spaces={spaces}
            selectedSpaceId={currentCalSelectedSpaceId}
            onSpaceSelected={handleSpaceSelected}
          />
          <div className="ExternalCalSelection_select-space-separator" />
        </>
      )}

      <Text typeface="body-2-m" className="ExternalCalSelection_select-cal-type-type-title">
        {ExternalCalSelectionStrings.selectCalTypeTitle}
      </Text>

      <ExternalCalButton
        title={ExternalCalSelectionStrings.syncCalendarTitle}
        desc={ExternalCalSelectionStrings.syncCalendarDesc}
        showRecommendedBadge={true}
        onClick={handleSyncCalSelected}
        isChecked={calendarType === CAL_TYPE_SYNC}
      />

      <ExternalCalButton
        title={ExternalCalSelectionStrings.icalTitle}
        desc={ExternalCalSelectionStrings.icalDesc}
        showRecommendedBadge={false}
        onClick={handleICalSelected}
        isChecked={calendarType === CAL_TYPE_ICAL}
      />
    </div>
  );
};

export default ExternalCalSelection;
